module.exports = __webpack_public_path__ + "img/horizontal_1_1_8011.2ff623cc.png";